import {ParentWindowNotifierService} from 'services';
import {NotifyClientResult} from 'types';
import {nativeInterfaceUtils} from 'utils';

import {ClientNotifier} from '../ClientNotifier';

export class ParentWindowNotifier extends ClientNotifier {
    notify = (name: string, data?: any): NotifyClientResult => {
        const payload = {type: 'client-event', event: {name, data}};
        const {success, error} = ParentWindowNotifierService.notify(payload);

        return {
            name,
            success,
            error
        };
    };

    formatResult = nativeInterfaceUtils.formatNativeInterfaceMethodResult;
}
